import {memo, useEffect} from 'react'

import {APP_VERSION} from '../config'
import {useUsage} from '../hooks/useUsage.ts'

export const AppInit = memo(function AppInit() {
  const usage = useUsage()
  useEffect(() => {
    usage('app loaded', {version: APP_VERSION})
  }, [usage])

  return null
})
